import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  Text,
  Flex,
  Box,
  Center,
  useDisclosure,
  Skeleton,
} from '@chakra-ui/react';
import {
  useAppSelector,
  useMediationByIdQuery,
  usePaymentOptionsQuery,
  usePaymentResumeQuery,
  useSupportQuery,
} from '@spartalabs/pdc-core';
import { ComeBackHeader, Container, Unauthorized } from 'components';
import { CardSkele } from 'components/Skeletons/Card';
import { ContactModal } from './components/ContactModal';
import { Stepper } from './components/Stepper';
import { CustomTable } from './components/TableCard';
import { extractlabels, mediationLabels, paymentlabels } from './const';

export const Payment: React.FC = () => {
  const permissions = useAppSelector(
    state => state.authSlicer.user.permissions,
  );

  const { id } = useParams();
  const location = useLocation();

  const {
    data: mediationData,
    isLoading: mediationLoading,
    isError: mediationError,
  } = useMediationByIdQuery({
    id: id || '-',
  });

  const {
    data: extractData,
    isLoading: extractLoading,
    isError: extractError,
  } = usePaymentResumeQuery({ id: id || '-' });

  const {
    data: paymentData,
    isLoading: paymentLoading,
    isError: paymentError,
  } = usePaymentOptionsQuery({
    id: id || '-',
  });

  const {
    data: supportData,
    isLoading: supportLoading,
    isError: supportError,
  } = useSupportQuery({
    id: id || '',
  });

  const step1Ref = useRef<HTMLDivElement | null>(null);
  const step2Ref = useRef<HTMLDivElement | null>(null);
  const step3Ref = useRef<HTMLDivElement | null>(null);

  const [step, setStep] = useState(1);
  //const [index, setIndex] = useState(0);

  const [steps, setSteps] = useState([
    { number: 1, h: '210px' },
    { number: 2, h: '200px' },
    { number: 3, h: '0' },
  ]);

  const { isOpen, onOpen, onClose } = useDisclosure();
  //   const {handleToast} = useCustomToast();
  const navigate = useNavigate();

  useEffect(() => {
    if (step1Ref.current && step2Ref.current && step3Ref.current)
      setSteps([
        { number: 1, h: step1Ref.current?.clientHeight + 40 + 'px' },
        { number: 2, h: step2Ref.current?.clientHeight - 0 + 'px' },
        { number: 3, h: '0' },
      ]);
  }, [extractLoading, paymentLoading, mediationLoading]);

  {
    /* 

    const PaymentFormSchema = z.object({
  justification: z
    .string({
      required_error: 'Campo obrigatório',
    })
    .nonempty({ message: 'Campo obrigatório' }),
});
      const userName = useAppSelector(state => state.authSlicer.user.name);
      const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<{ justification: string }>({
    resolver: zodResolver(PaymentFormSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });
     const [setMediation] = useHandleMediationMutation();
    const handleMediation = useCallback(
    async (
      approve: boolean,
      justification: string,
      index?: number,
      step?: number,
    ) => {
      try {
        await setMediation({ id: '111', approve, justification });
        index && setIndex(index);
        step && setStep(step);
        toast({
          position: 'top',
          title: approve ? 'Mediação aprovada' : 'Dados enviados com sucesso!',
          description: approve
            ? 'Obrigado pela confirmação! Logo a fatura estará disponível para pagamento'
            : 'Obrigado pelo envio! Logo nosso time ira entrar em contato a respeito do pedido',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      } catch {
        toast({
          position: 'top',
          title: 'Erro',
          description: 'Algo deu errado ao enviar a validação',
          status: 'error',
          duration: 2000,
          isClosable: true,
        });
      }
    },
    [],
  );
*/
  }

  useEffect(() => {
    if (paymentData && extractData) return setStep(3);

    if (extractData) setStep(2);
  }, [paymentData, extractData]);

  if (!permissions?.includes('finan')) return <Unauthorized />;

  return (
    <Container>
      <ContactModal
        error={supportError}
        loading={supportLoading}
        data={supportData}
        isOpen={isOpen}
        onClose={onClose}
      />
      <ComeBackHeader
        actionText="Voltar"
        navigateTo={() =>
          navigate('/faturamento', {
            state: { selected: location.state?.selected },
          })
        }
        customTitle={
          <Center flexWrap="wrap" w="100%">
            <Text
              mr="8px"
              textAlign="center"
              ml={{ md: '0px', base: '16px' }}
              fontSize="18px"
              color="text.100"
            >
              Demonstrativo de faturamento do mês de{' '}
              <b>{mediationData?.month?.toLowerCase()}</b>
            </Text>
            {mediationLoading && (
              <CardSkele>
                <Skeleton w="116px" h="16px" />
              </CardSkele>
            )}
          </Center>
        }
      />

      <Flex mt="24px">
        <Stepper currentStep={step} steps={steps} />
        <Flex w="100%" direction="column" gap="40px">
          <Box>
            <CustomTable
              attachment={{
                type: 'Medição',
                id: mediationData?.attachmentId || null,
                mediationId: id,
                costCenter: location.state?.selected.id || null,
              }}
              onOpen={onOpen}
              isMediation
              ariaText="Baixar arquivo com detalhes da mediação"
              title="Medição"
              actionText="Ver arquivo"
              ref={step1Ref}
              data={mediationData?.items}
              labels={mediationLabels}
              total={mediationData?.total}
              loading={mediationLoading}
              error={mediationError}
            />
            <Text mt="16px" fontSize="12px" textColor="grey.600">
              *A fatura será emitida automaticamente por nosso sistema 5 dias
              após a emissão/validação.
            </Text>
          </Box>

          {/* 
            <Box ref={step2Ref}>
              <Card
                py="0px"
                px="0px"
                borderRadius="16px"
                justifyContent="start"
                w={{ base: '100%', lg: '833px' }}
              >
                <Flex
                  borderBottom="1px solid"
                  borderColor="grey.200"
                  px="16px"
                  py="24px"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Text fontWeight="semibold" textColor="text.100">
                    Validação
                  </Text>
                  <Button
                    onClick={onOpen}
                    border="1px solid"
                    fontWeight="400"
                    variant="outline"
                  >
                    Entrar em contato
                  </Button>
                </Flex>
                {index === 0 && (
                  <Box pb="60px" px="16px">
                    <Text mt="40px" textColor="text.100">
                      Deseja aprovar seu faturamento?{' '}
                    </Text>

                    <Flex
                      justifyContent={{ base: 'center', md: 'start' }}
                      mt="16px"
                      w="100%"
                    >
                      <Button
                        onClick={() => setIndex(2)}
                        mr="16px"
                        w="164px"
                        variant="outline"
                      >
                        Não
                      </Button>
                      <Button
                        onClick={() => {
                          handleMediation(true, '', 1, 4);
                          setIndex(1);
                        }}
                        w="164px"
                      >
                        Sim
                      </Button>
                    </Flex>
                  </Box>
                )}
                {index === 1 && (
                  <Box pb="60px" px="16px">
                    <Text mt="40px" textColor="text.100">
                      Aprovação realizada por <b>{userName}</b> em{' '}
                      <b>
                        {new Date().toLocaleString('en-GB', {
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                        })}
                      </b>
                    </Text>
                    <Text mt="16px" textColor="text.100">
                      A fatura estará disponível para pagamento em até 5 dias.
                    </Text>
                  </Box>
                )}
                {index === 2 && (
                  <Box pb="24px" px="16px">
                    <Text my="16px" textColor="text.100">
                      Detalhe no campo abaixo seu pedido de esclarecimento
                    </Text>

                    <Textarea
                      {...register('justification')}
                      fontSize="12px"
                      textColor="text.100"
                      placeholder="Insira seu questionamento aqui"
                      h="120px"
                      border="1px solid"
                      borderColor="grey.200"
                    />
                    <Text
                      alignSelf="start"
                      pt="8px"
                      pl="4px"
                      color="red.200"
                      fontSize="sm"
                    >
                      {errors.justification?.message}
                    </Text>

                    <Flex
                      justifyContent={{ base: 'center', md: 'end' }}
                      mt="16px"
                      w="100%"
                    >
                      <Button
                        onClick={() => setIndex(0)}
                        mr="16px"
                        w="164px"
                        variant="outline"
                      >
                        Voltar
                      </Button>
                      <Button
                        onClick={handleSubmit(data =>
                          handleMediation(false, data.justification, 3),
                        )}
                        w="164px"
                      >
                        Enviar
                      </Button>
                    </Flex>
                  </Box>
                )}
                {index === 3 && (
                  <Center my="26px" flexDirection="column">
                    <Icon
                      borderRadius="100px"
                      padding="16px"
                      bg="ocean.200"
                      w="80px"
                      h="80px"
                      as={IoIosMail}
                      color="white"
                    />
                    <Text
                      mt="8px"
                      fontWeight="medium"
                      color="black"
                      fontSize="18px"
                    >
                      Mensagem enviada com sucesso!
                    </Text>
                    <Text mt="4px" color="text.200" fontSize="12px">
                      Em breve nosso time ira entra em contato a respeito.
                    </Text>
                  </Center>
                )}
                {index === 4 && (
                  <Center my="26px" flexDirection="column">
                    <Icon
                      borderRadius="100px"
                      padding="16px"
                      bg="ocean.200"
                      w="80px"
                      h="80px"
                      as={IoLogoUsd}
                      color="white"
                    />
                    <Text
                      mt="8px"
                      fontWeight="medium"
                      color="black"
                      fontSize="18px"
                    >
                      Fatura
                    </Text>
                    <Text mt="4px" color="text.200" fontSize="12px">
                      Disponível para pagamento
                    </Text>
                  </Center>
                )}
              </Card>
            </Box>
*/}
          <CustomTable
            attachment={{
              type: 'Fatura',
              id: extractData?.attachmentId || null,
              mediationId: id,
              costCenter: location.state?.selected.id || null,
            }}
            ariaText="Baixar arquivo com a fatura"
            title="Fatura"
            actionText="Ver fatura"
            ref={step2Ref}
            data={step >= 2 ? extractData?.items : null}
            labels={extractlabels}
            loading={extractLoading}
            error={extractError}
          />

          <CustomTable
            attachment={{
              type: 'Boleto',
              ids: paymentData?.attachmentId,
              mediationId: id,
              costCenter: location.state?.selected.id || null,
            }}
            ref={step3Ref}
            ariaText="Baixar arquivo com o boleto de pagamento"
            title="Pagamento"
            actionText="Ver boleto"
            data={step >= 3 ? paymentData?.items : null}
            labels={paymentlabels}
            loading={paymentLoading}
            error={paymentError}
          />
        </Flex>
      </Flex>
    </Container>
  );
};
